import { render, staticRenderFns } from "./TransactionRecord.vue?vue&type=template&id=4e83523f&scoped=true"
import script from "./TransactionRecord.vue?vue&type=script&lang=js"
export * from "./TransactionRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83523f",
  null
  
)

export default component.exports